import { ErrorsType } from "..";
import { Custom } from "./Custom";

interface Props {
    tasOccurrenceNumber?: string;
    isLoading: boolean;
    supportType?: string;
    customerComment: string;
    handleChangeComment: (comment: string) => void;
    errors: ErrorsType;
    partOrComponentName: string;
    handlePartOrComponentName: (value: string) => void;
    partNumber: string;
    handlePartNumber: (value: string) => void;
    problemDescription: string;
    handleProblemDescription: (value: string) => void;
    diagnosticAndResults: string;
    handleDiagnosticAndResults: (value: string) => void;
    problemSteps: string;
    handleProblemSteps: (value: string) => void;
}

const AdditionalDataTas = ({
    tasOccurrenceNumber,
    isLoading,
    customerComment,
    handleChangeComment,
    supportType,
    errors,
    partOrComponentName,
    handlePartOrComponentName,
    partNumber,
    handlePartNumber,
    problemDescription,
    handleProblemDescription,
    diagnosticAndResults,
    handleDiagnosticAndResults,
    problemSteps,
    handleProblemSteps
}: Props) => {

    const supportTypesWithProblemSteps = [
        'GEARBOX',
        'CHASSIS',
        'SUPPORT_AXLE',
        'FRONT_AXLE',
        'CLUTCH',
        'ENGINE',
        'E_DELIVERY',
        'WHEEL',
        'STEERING_SYSTEM',
        'BRAKE_SYSTEM',
        'ELECTRICAL_SYSTEM',
        'DRIVE_AXLE',
        'SUSPENSION',
        'POWER_TAKEOFF',
        'TRANSMISSION',
    ];

    const shouldShowProblemSteps = supportTypesWithProblemSteps.includes(supportType as string);

    console.log('@@@', supportType)

    return (
        <div className="width-100pct height-100pct border rounded padding-15">
            <div className="margin-bottom-15">
                <span className="text-size-14 text-medium text-color-black">2. Dados adicionais</span>
            </div>
            <div className="width-100pct display-flex flex-row gap-20">
                <Custom.Input label='Número do contrato*' value={tasOccurrenceNumber} disabled={true} isLoading={isLoading} />

                <Custom.Input
                    label='Nome da Peça ou Componente'
                    value={partOrComponentName}
                    isLoading={isLoading}
                    onChange={handlePartOrComponentName}
                    error={errors.partOrComponentName}
                />
                <Custom.Input
                    label='Nº da peça VW/MAN'
                    value={partNumber}
                    isLoading={isLoading}
                    onChange={handlePartNumber}
                    error={errors.partNumber}
                />
            </div>


            <div className="width-100pct">
                <Custom.TextArea
                    label={"Qual a reclamação do cliente?"}
                    value={customerComment}
                    onChange={handleChangeComment}
                    isLoading={isLoading}
                    error={errors.customerComment}
                />
            </div>

            {supportType === 'CABIN' ? (
                <div className="width-100pct">
                    <Custom.TextArea
                        label={"O que aconteceu?"}
                        value={problemDescription}
                        onChange={handleProblemDescription}
                        isLoading={isLoading}
                        error={errors.problemDescription}
                    />
                </div>
            ) : null}

            {shouldShowProblemSteps ? (
                <div className="width-100pct">
                    <Custom.TextArea
                        label={"É possível reproduzir? Informe o passo-a-passo."}
                        value={problemSteps}
                        onChange={handleProblemSteps}
                        isLoading={isLoading}
                        error={errors.problemSteps}
                    />
                </div>
            ) : null}

            <div className="width-100pct">
                <Custom.TextArea
                    label={"Relate procedimentos de diagnóstico e resultados"}
                    value={diagnosticAndResults}
                    onChange={handleDiagnosticAndResults}
                    isLoading={isLoading}
                    error={errors.diagnosticAndResults}
                />
            </div>
        </div >
    )
}

export default AdditionalDataTas;